import BaseComponent from '../base_component/base_component';

export default class Footer extends BaseComponent {

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        this.load(true);
    }

    load(initialLoad= false) {
        $('.user-panel-component').find('.user-panel__minimise').click(() => this.toggleFooterSize());
        $('.close-footer').click(() => this.closeFooter());
    }

    toggleFooterSize() {
        let footer = $('.footer-component footer');
        if (footer.hasClass('minimised')) {
            footer.removeClass('minimised');
        } else {
            footer.addClass('minimised');
        }
    }

    closeFooter() {
        $('.footer-component footer').addClass('hidden');
    }
}